<template>
  <div class="ui container">
    <div class="ui text logo container">
      <img src="@/assets/header-logo.svg" class="ui centered medium image" />
    </div>
    <div class="ui left aligned text container" v-if="isHost">
      <div class="ui segments">
        <div class="ui segment">
          <div class="ui list">
            <div class="item">
              <i class="check icon"></i> Dit is het quizmasterscherm voor de
              bediening! (PIN: {{ $store.state.pinCode }})
            </div>
            <div class="item">
              <i class="arrow right icon"></i> Open het scherm voor de spelers
              op een ander toestel:
            </div>
          </div>
        </div>
        <div class="ui segment">
          <div class="ui form">
            <div class="field">
              <label
                >Open deze link bv. op een laptop die via HDMI verbonden is met
                een TV scherm:</label
              >
              <div class="ui fluid massive action input">
                <input
                  type="text"
                  id="url"
                  onClick="this.select()"
                  :value="`http://${hostName}/${$store.state.gameId}`"
                  readonly
                />
                <button
                  class="ui right labeled icon clipboard button"
                  data-clipboard-target="#url"
                >
                  <i class="copy icon"></i> Kopieer URL
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="ui segment">
          <div
            class="ui right labeled icon orange massive fluid button"
            id="start-quiz"
            @click.once="startGame"
          >
            <i class="play icon"></i> Start Quiz [ENTER]
          </div>
        </div>
        <div class="ui segment">
          <div class="ui info icon message">
            <i class="laptop icon"></i>
            <div class="content">
              <div class="header">Hoe het deelnemersscherm opzetten?</div>
              Open bovenstaande unieke url op een andere pc of mobiel apparaat.
              <br />In een ideale situatie bedien je alles met een pc of tablet
              en toon je het deelnemersscherm via een beamer of TV (hdmi of
              Chromecast). <br />Bij vragen of opmerkingen kan je ons
              contacteren via
              <a href="mailto:hallo@kwis.app">hallo@kwis.app</a> (verwacht een
              reactie binnen de 24u).
            </div>
          </div>
        </div>
        <div class="ui segment">
          <div class="ui error icon message">
            <i class="youtube icon"></i>
            <div class="content">
              <div class="header">Opgepast!</div>
              Smartphones of tablets kunnen Youtubefilmpjes niet automatisch
              afspelen. Voor het hoofdscherm gebruik je dus beter een PC waar
              dit wel werkt.
            </div>
          </div>
        </div>
        <div class="ui segment">
          <div class="ui info icon message">
            <i class="idea icon"></i>
            <div class="content">
              <div class="header">Wist je dat...</div>
              ...alle spelers en toeschouwers je quiz kunnen meevolgen op hun
              smartphone, tablet of laptop. Het maakt niet uit of ze zich aan de
              andere kant van de aardbol bevinden. Ze hoeven enkel de unieke url
              te openen die bovenaan deze pagina staat!
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui text container" v-else>
      <div class="ui attached segments">
        <div class="ui center aligned segment">
          <p><i class="check icon"></i> Deelnemersscherm klaar!</p>
        </div>
        <div class="ui center aligned segment">
          <p>
            <i class="hourglass half icon"></i> Even wachten op de quizmaster...
          </p>
        </div>
        <div class="ui segment">
          <div
            class="ui labeled bottom huge fluid orange icon button"
            @click="$store.dispatch('toggleFullscreen')"
          >
            <i class="maximize icon"></i> Volledig Scherm
          </div>
        </div>
        <div class="ui segment">
          <div class="ui info icon message">
            <i class="maximize icon"></i>
            <div class="content">
              <div class="header">Fullscreen niet vergeten!</div>
              Voor een optimale speelervaring open je dit scherm best in
              fullscreenmodus. Hiervoor kan je op bovenstaande knop klikken of
              op de f-toets.
            </div>
          </div>
        </div>
        <div class="ui segment">
          <div class="ui info icon message">
            <i class="mobile icon"></i>
            <div class="content">
              <div class="header">
                Volg mee met je smartphone: {{ hostName }}/{{
                  $store.state.gameId
                }}
              </div>
              Kandidaten en supporters kunnen de quiz meevolgen op hun eigen
              smarthpone door deze url te openen:
              <strong>{{ hostName }}/{{ $store.state.gameId }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Mousetrap from 'mousetrap';
import Clipboard from 'clipboard';
import alertify from 'alertify.js';

export default {
  name: 'lobby',
  data() {
    return {
      hostName: window.location.hostname
    };
  },
  computed: {
    ...mapGetters(['isHost'])
  },
  created() {
    this.addKeyboardShortcuts();
  },
  mounted() {
    const clipboard = new Clipboard('.clipboard');
    clipboard.on('success', e => {
      alertify.log('URL Gekopieerd!');
      e.clearSelection();
    });
  },
  methods: {
    startGame() {
      this.$store.dispatch('startGame');
      this.$store.dispatch('syncGame');
    },
    addKeyboardShortcuts() {
      Mousetrap.bind('enter', () => {
        const startButton = document.querySelector('#start-quiz');
        if (startButton) startButton.click();
        return false;
      });
    }
  }
};
</script>

<style scoped>
.ui.logo.container {
  margin-bottom: 3em;
}
.ui.image {
  margin-top: 30px;
}
.ui.form .field > label {
  font-size: 1.2em;
}
.ui.header {
  font-size: 3rem;
  padding-bottom: 0;
}
.ui.list > .item,
p {
  font-size: 1.5rem;
}
.ui.list .list > .item > i.icon,
.ui.list > .item > i.icon {
  margin-top: -0.1em;
}
.ui.action.input > .button,
.ui.action.input > .buttons {
  font-size: 1.5rem;
}
</style>
